import request from '@/service/request'
import basicRequest from '@/service/basicRequest'
import loginRequest from '@/service/loginRequest'
import sharedRequest from '@/service/sharedRequest'

/**
 * 登录相关
 */

// 注册新用户
export function registerService(data) {
    return loginRequest.post('user/register', data);
}

// 登录
export function loginService(data) {
    return loginRequest.post('/account/login', data);
}

// 退出
export function logoutService(headers) {
    return loginRequest.get('/account/logout', headers);
}

// 手机号登录
export function phoneLoginService(data) {
    return loginRequest.post('/account/phoneLogin', data);
}

// 发送手机验证码
export function sendValidateNoService(data, headers) {
    return loginRequest.post('/account/sendPhoneValidateNo', data, headers);
}

// 验证手机验证码
export function validateMessageNo(data) {
    return loginRequest.post('/account/checkSendPhoneValidateNo', data);
}

// 发送邮箱验证码
export function sendMailValidateNoService(data, headers) {
    return loginRequest.post('/account/sendEmailValidateNo', data, headers);
}

// 获取人机验证图片
export function getVerificatePicture(data) {
    return loginRequest.post('/account/getHumanVerification', data);
}

// 人机图片验证
export function getVerificateResult(data) {
    return loginRequest.post('/account/humanVerification', data);
}

// 修改密码
export function resetPasswordService(data) {
    return loginRequest.put('/user/forgetPassword', data);
}

// 用户修改密码
export function userChangePasswword(data, headers) {
    return loginRequest.put('/user/userChangePassword', data, headers);
}

// 用户修改手机号
export function userChangePhone(data, headers) {
    return loginRequest.put('/user/userChangePhone', data, headers);
}

// 用户修改邮箱
export function userChangeEmail(data, headers) {
    return loginRequest.put('/user/userChangeEmail', data, headers);
}

// 用户修改公司名
export function userChangeCompany(data, headers) {
    return loginRequest.put('/user/userChangeCompany', data, headers);
}

// 用户修改企业类型
export function userChangeEnterpriseType(data, headers) {
    return loginRequest.put('/user/userEnterpriseType', data, headers);
}

// 用户修改所在省份
export function userChangeProvince(data, headers) {
    return loginRequest.put('/user/userChangeProvince', data, headers);
}

// 用户修改名称
export function userChangeName(data, headers) {
    return loginRequest.put('/user/userChangeName', data, headers);
}
// 用户修改账号
export function userChangeUserName(data, headers) {
    return loginRequest.put('/user/userChangeUserName', data, headers);
}

// 用户修改职位
export function userChangePosition(data, headers) {
    return loginRequest.put('/user/userChangePosition', data, headers);
}

// 用户保存头像地址
export function userSavePhoto(data, headers) {
    return loginRequest.post('/user/uploadPhoto', data, headers);
}

// 获取示例项目使用的Token
export function getDemoProjTokenService(data) {
    return request.post('/share/v3/getSharedToken', data);
}

// 根据现有token刷新token
export function refreshTokenService(data) {
    return basicRequest.post('/account/refreshToken', data);
}

// 根据clientId获取token
export function getClientTokenService(data) {
    return loginRequest.post('/account/getTokenByClientId', data);
}

/**
 * 项目成员管理
 */

// 获取项目列表
export function getOptionalProjListService(data) {
    return request.post('/v3/ProjectUserRelation/OptionalProjectList', data);
}

// 获取用户项目关系列表
export function getUserProjRelationListService(data) {
    return request.post('/v3/ProjectUserRelation/List', data);
}

// 获取用户项目未绑定用户列表
export function getProjUnBindUserListService(data) {
    return request.post('/v3/ProjectUserRelation/UnBindUserList', data);
}

// 添加项目用户关系
export function createProjUserRelationService(data) {
    return request.post('/v3/ProjectUserRelation/Create', data);
}

// 删除项目用户关系
export function delProjUserRelationService(data) {
    return request.delete('/v3/ProjectUserRelation/Delete', { data });
}

// 批量删除项目用户关系
export function batchDelProjUserRelationService(data) {
    return request.delete('/v3/ProjectUserRelation/BatchDelete', { data });
}

/**
 * 项目内成员管理
 */

// 获取用户项目关系列表
export function getUserProjRelationListByProjService(data) {
    return request.post('/v3/ProjectUserRelation/ByProject/List', data);
}

// 获取用户项目关系列表
export function getProjUnBindUserListByProjService(data) {
    return request.post('/v3/ProjectUserRelation/ByProject/UnBindUserList', data);
}

// 添加项目用户关系
export function createProjUserRelationByProjService(data) {
    return request.post('/v3/ProjectUserRelation/ByProject/Create', data);
}

// 删除项目用户关系
export function delProjUserRelationByProjService(data) {
    return request.delete('/v3/ProjectUserRelation/ByProject/Delete', { data });
}

// 批量删除项目用户关系
export function batchDelProjUserRelationByProjService(data) {
    return request.delete('/v3/ProjectUserRelation/ByProject/BatchDelete', { data });
}


/**
 * 项目列表
 */

// 获取单项目列表
export function getSingleProjectList(data) {
    return request.post('/v3/list', data);
}

// 获取项目列表
export function getProjListService(data) {
    return request.post('/v3/pagedList', data);
}

// 新建单项目
export function addSingleProject(data) {
    return request.post('/v3/create', data);
}

// 修改单项目
export function modifySingleProject(data) {
    return request.put('/v3/update', data);
}

// 修改单项目名称
export function modifySingleProjectName(data) {
    return request.put('/v3/modifyName', data);
}

// 删除单项目
export function deleteProjService(projId, projName) {
    return request.delete(`/v3/delete/${projId}?projName=${encodeURIComponent(projName)}`);
}

// 退出项目校验
export function exitProjCheckService(projId) {
    return request.get(`/v3/ProjectUserRelation/ByProject/ExitProjectCheck/${projId}`);
}

// 移除项目管理人员校验
export function removeProjManagerCheckService(data) {
    return request.post('/v3/ProjectUserRelation/ByProject/DeleteCheck', data);
}

// 查询移交人员名称
export function getNewProjManagerService(data) {
    return request.post('/v3/ProjectUserRelation/ByProject/GetNewProjectManager', data);
}

// 移交项目
export function handoverProjService(data) {
    return request.post('/v3/ProjectUserRelation/ByProject/HandoverProject', data);
}

// 查询项目基本信息统计
export function singleProjectSummary(id) {
    return request.get(`/v3/base/summary/${id}`);
}

// 获取数据集概况信息
export function getProjectSummary(data) {
    return request.post('/dataSet/v3/getProjectSummary', data);
}

// 获取数据集变更信息
export function getProjectChangeLog(data) {
    return request.post('/dataSet/v3/getChangeLogs', data);
}

// 获取数据集变更详细信息
export function getProjectChangeLogDetail(data) {
    return request.post('/dataSet/v3/getChangeLogDetail', data);
}

/**
 * 文件管理
 */

// 获取文件上传信息
export function getFileInfoService(fileDataId) {
    return request.get(`/filemanage/v3/file/${fileDataId}`);
}

// 获取文件上传列表
export function getFileList(data) {
    return request.post('/filemanage/v3/list', data);
}

// 终止文件上传
export function deleteFileService(fileDataId) {
    return request.delete(`/fileManage/v3/delete/${fileDataId}`);
}

// 文件重新检验
export function reCheckFileService(fileDataId) {
    return request.post(`/fileManage/v3/recheckout/${fileDataId}`);
}

/**
 * 坐标系通用接口
 */

// 根据关键词查询坐标信息
export function queryCrsList(data) {
    return request.post('/baseData/v3/getCrs', data);
}

/**
 * 用户自定义视角相关接口
 */

// 获取用户自定义视角
export function getViewAngleService(data) {
    return request.post('/userDefined/v3/VisualAngle', data);
}

// 设置用户自定义视角
export function setViewAngleService(data) {
    return request.post('/userDefined/v3/SetVisualAngle', data);
}

/**
 * 数据管理-模型数据
 */

// 新手引导-获取用户引导状态 
export function getUserGuidance() {
    return request.get('/userGuidance/v3');
}

// 新手引导-禁用模型管理新手引导
export function disabledModelGuidanceService() {
    return request.get('/userGuidance/v3/DisableBeginner');
}

// 新手引导-禁用模型组管理新手引导
export function disabledModelGroupGuidanceService() {
    return request.get('/userGuidance/v3/DisableGroupBeginner');
}

// 根据节点id获取子节点
export function getBimTreeService(data) {
    return request.post('/modelTree/v3/getById', data);
}

// 添加层级节点
export function addBimLevelNodes(data) {
    return request.post('/modelTree/v3/addLevelNodes', data);
}

// 添加叶子节点
export function addBimLeafNodes(data) {
    return request.post('/modelTree/v3/addDataSet', data);
}

// 获取节点列表
export function getBimNodeList(data) {
    return request.post('/modelTree/v3/nodeList', data);
}

// 修改节点名称
export function modifyBimNodeName(data) {
    return request.put('/modelTree/v3/updateNodeName', data);
}

// 数据集引用校验
export function bimQuoteService(data) {
    return request.post('/modelTree/v3/setCoordinatesCheck', data);
}

// 设置坐标系信息
export function setBimCoordinatesService(data) {
    return request.put('/modelTree/v3/setCoordinates', data);
}

// 删除文件夹节点
export function deleteBimFolderNode(data) {
    return request.delete('/modelTree/v3/deleteNodes', { data });
}

// 删除数据集校验
export function deleteBimDataSetCheckService(data) {
    return request.delete('/modelTree/v3/deleteDataSets/check', { data });
}

// 删除数据集节点
export function deleteBimDataSetNode(data) {
    return request.delete('/modelTree/v3/deleteDataSets', { data });
}

// 移动节点
export function moveBimNode(data) {
    return request.put('/modelTree/v3/moveNodes', data);
}

// 获取历史版本
export function getHistoryVersion(nodeId) {
    return request.get(`/modelTree/v3/versionHistory/${nodeId}`);
}

// 获取版本变更详情日志
export function getVersionChangelog(versionId) {
    return request.get(`/modelTree/v3/versionChangelog/${versionId}`);
}

// 获取数据集下的文件列表
export function getBimDatasetFiles(data) {
    return request.post('/modelTree/v3/modelFile/list', data);
}

// 获取数据集转换配置
export function getBimConvertConfigService(dataSetId) {
    return request.get(`/modelFile/v3/getConvertConfig/${dataSetId}`);
}

// 链接模型设置主文件
export function setLinkMainFileService(data) {
    return request.post('/modelFile/v3/setLinkMainFile', data);
}

// 模型预览生成缩略图
export function updateBimThumbnailService(data) {
    return request.post('/modelTree/v3/updateThumbnail', data);
}

// rvt外部贴图列表
export function queryUvMapListService(data) {
    return request.post('/modelTree/v3/UvMappings/list', data);
}

// 上传rvt外部贴图申请
export function createRvtUvUploadService(data) {
    return request.post('/modelFile/v3/rvtuv/create', data);
}

// 删除rvt外部贴图
export function deleteRvtUvService(data) {
    return request.post('/modelFile/v3/rvtuv/delete', data);
}

// 模型管理文件上传校验
export function createInFolderCheckService(data) {
    return request.post('/modelFile/v3/createInFolder/check', data);
}

// 模型组管理文件上传校验
export function createInDataSetCheckService(data) {
    return request.post('/modelFile/v3/createInDataSet/check', data);
}

// 向文件夹中上传文件
export function createBimFolderUpload(data) {
    return request.post('/modelFile/v3/createInFolder', data);
}

// 向数据集中上传文件
export function createBimDataSetUpload(data) {
    return request.post('/modelFile/v3/createInDataSet', data);
}

// 暂停文件上传
export function pauseBimFile(data) {
    return request.post('/modelFile/v3/pause', data);
}

// 批量暂停文件上传
export function batchPauseBimFile(data) {
    return request.post('/modelFile/v3/batch/pause', data);
}

// 删除上传的文件
export function deleteBimFiles(data) {
    return request.post('/modelFile/v3/deleteFiles', data);
}

// 配置转换参数
export function configConvertParam(data) {
    return request.post('/modelFile/v3/configConvert', data);
}

// 批量转换配置
export function batchConfigConvertParam(data) {
    return request.post('/modelFile/v3/batchConvertConfig', data);
}

// 根据项目id获取项目转换配置
export function getProjConvertConfigService(projId) {
    return request.get(`/modelFile/v3/getBatchConvertConfig/${projId}`);
}

// 获取三维视图信息
export function getThreedviewService(data) {
    return request.post('/modelFile/v3/getThreeDviews', data);
}

// 获取图纸信息
export function getViewSheetService(data) {
    return request.post('/modelFile/v3/getViewSheetInfo', data);
}

// 提交转换
export function addConvertQueue(data) {
    return request.post('/modelFile/v3/addToConvertQueue', data);
}

// 数据集共面列表
export function coplaneListService(data) {
    return request.post('/dataSet/v3/coplane/list', data);
}

// 保存数据集共面
export function saveCoplaneService(data) {
    return request.post('/dataSet/v3/coplane/save', data);
}

// 重置数据集共面
export function resetCoplaneService(data) {
    return request.post('/dataSet/v3/coplane/reset', data);
}

// 放弃保存数据集共面
export function giveUpCoplaneService(data) {
    return request.post('/dataSet/v3/coplane/giveUp', data);
}

// 数据集共面保存状态
export function getCoplaneStatusService(data) {
    return request.post('/dataSet/v3/coplane/status', data);
}

// 发布数据集共面
export function publishCoplaneService(data) {
    return request.post('/dataSet/v3/coplane/publish', data);
}

// 是否可以进行版本对比
export function isCompareService(data) {
    return request.post('/dataSet/v3/supportInvariantUniqueId', data);
}

// 发起版本对比
export function startVersionContrast(data) {
    return request.post('/versionContrast/v3/create', data);
}

// 获取版本对比列表
export function getVersionContrastList(data) {
    return request.get('/versionContrast/v3/list', data);
}

// 获取版本对比结果概览
export function getVersionContrastOverview(data) {
    return request.post('/versionContrast/v3/overview', data);
}

// 获取版本对比文件列表
export function getVersionContrastFileList(data) {
    return request.post('/versionContrast/v3/fileList', data);
}

// 获取版本对比构件列表
export function getVersionContrastElemList(data) {
    return request.post('/versionContrast/v3/elemList', data);
}

// 获取版本对比属性对比结果
export function getParamsContrastResultService(data) {
    return request.post('/versionContrast/v3/paramsContrastInfo', data);
}


// 是否具有二维图纸信息
export function isCadMapExistService(data) {
    return request.post('/engine/v3/cadmap/exists', data);
}

// 获取二维图纸列表
export function getCadMapList(data) {
    return request.post('/engine/v3/cadMap/list', data);
}

// 根据构件id获取图纸元素id
export function getCadIdByElemId(data) {
    return request.post('/engine/v3/cadMap/cadId/byElementId', data);
}

// 根据图纸元素id获取构件id
export function getElemIdByCadId(data) {
    return request.post('/engine/v3/cadMap/byElementId/byCadId', data);
}

// 是否具有空间信息信息
export function isRoomExistService(data) {
    return request.post('/engine/v3/room/exists', data);
}

// 获取空间信息
export function getRoomList(data) {
    return request.post('/engine/v3/room/list', data);
}

// 获取空间属性
export function getRoomInfo(data) {
    return request.post('/engine/v3/room/element/parameter/list', data);
}

/**
 * 二开接口相关
 */

// 获取房间目录树构件
export function getRoomElement(data) {
    return request.post('/element/v3/getRoomTreeChildren', data);
}

/**
 * 数据管理-遥感影像
 */

// 根据项目id获取资源目录树
export function getRsTreeService(data) {
    return request.post('/demTree/v3/getById', data);
}

// 添加层级节点
export function addRsLevelNodes(data) {
    return request.post('/demTree/v3/addLevelNodes', data);
}

// 获取节点列表
export function getRsNodeList(data) {
    return request.post('/demTree/v3/nodeList', data);
}

// 修改节点信息
export function modifyRsNodeName(data) {
    return request.put('/demTree/v3/updateNodeName', data);
}

// 删除数据集校验
export function deleteRsDataSetCheckService(data) {
    return request.delete('/demTree/v3/deleteDataSets/check', { data });
}

// 删除节点
export function deleteRsNode(data) {
    return request.delete('/demTree/v3/deleteNodes', { data });
}

// 移动节点
export function moveRsNode(data) {
    return request.put('/demTree/v3/moveNodes', data);
}

// 获取遥感数据集下的文件列表
export function getDemDatasetFiles(data) {
    return request.post('/demTree/v3/file/list', data);
}

// 遥感数据预览生成缩略图
export function updateRsThumbnailService(data) {
    return request.post('/demTree/v3/updateThumbnail', data);
}

// 遥感影像文件上传校验
export function createRsInFolderCheckService(data) {
    return request.post('/demFile/v3/createInFolder/check', data);
}

// 创建文件上传
export function createRsFoldertUpload(data) {
    return request.post('/demFile/v3/createInFolder', data);
}

// 暂停文件上传
export function pauseRsFile(data) {
    return request.post('/demFile/v3/pause', data);
}

// 批量暂停文件上传
export function batchPauseDemFile(data) {
    return request.post('/demFile/v3/batch/pause', data);
}

/**
 * 数据管理-WMTS地图服务
 */

// 根据项目id获取资源目录树
export function getWmtsTreeService(data) {
    return request.post('/wmtsTree/v3/getById', data);
}

// 添加层级节点
export function addWmtsLevelNodes(data) {
    return request.post('/wmtsTree/v3/addLevelNodes', data);
}

// 获取节点列表
export function getWmtsNodeList(data) {
    return request.post('/wmtsTree/v3/nodeList', data);
}

// 修改节点信息
export function modifyWmtsNodeName(data) {
    return request.put('/wmtsTree/v3/updateNodeName', data);
}

// 删除数据集校验
export function deleteWmtsDataSetCheckService(data) {
    return request.delete('/wmtsTree/v3/deleteDataSets/check', { data });
}

// 删除节点
export function deleteWmtsNode(data) {
    return request.delete('/wmtsTree/v3/deleteNodes', { data });
}

// 移动节点
export function moveWmtsNode(data) {
    return request.put('/wmtsTree/v3/moveNodes', data);
}

// 重新解析WMTS数据集
export function reCheckWmtsService(data) {
    return request.post('/wmtsTree/v3/reCheckoutConfig', data);
}

// WMTS数据预览生成缩略图
export function updateWmtsThumbnailService(data) {
    return request.post('/wmtsTree/v3/updateThumbnail', data);
}

// 创建Wmts模板
export function createWmtsTemplate(data) {
    return request.post('/wmtsTemplate/v3/create', data);
}

// 创建Capability文件上传申请
export function createWmtsInFolderService(data) {
    return request.post('/wmtsTemplate/v3/createInFolder', data);
}

// 根据URL解析Capability信息
export function analyzeCapabilityService(data) {
    return request.post('/wmtsTemplate/v3/capabilityAnalyze', data);
}

// 根据Capability创建Wmts服务
export function createServeByCapabilityService(data) {
    return request.post('/wmtsTemplate/v3/createByCapability', data);
}


// 获取Wmts模板列表
export function getWmtsTemplateService(data) {
    return request.post('/wmtsTemplate/v3/list', data);
}

// 更新Wmts模板
export function modifyWmtsTemplate(data) {
    return request.put('/wmtsTemplate/v3', data);
}

// 更新Wmts固有模板
export function modifyWmtsIntrinsicTemplate(data) {
    return request.put('/wmtsTemplate/v3/intrinsic', data);
}

// 删除Wmts模板
export function deleteWmtsServeService(templateId) {
    return request.delete(`/wmtsTemplate/v3/${templateId}`);
}

// 删除Wmts固有模板
export function deleteWmtsPreServeService(templateId) {
    return request.delete(`/wmtsTemplate/v3/intrinsic/${templateId}`);
}

// 基于模板配置创建Wmts
export function configWmtsByTemplate(data) {
    return request.post('/wmtsTree/v3/createConfig', data);
}

// 获取WMTS数据集的配置信息
export function getWmtsConfigService(data) {
    return request.post('/wmtsTree/v3/getConfig', data);
}

// 更新Wmts配置
export function updateWmtsConfig(data) {
    return request.post('/wmtsTree/v3/updateConfig', data);
}

/**
 * 数据管理-倾斜摄影
 */

// 根据项目id获取资源目录树
export function getOsgbTreeService(data) {
    return request.post('/osgbTree/v3/getById', data);
}

// 添加层级节点
export function addOsgbLevelNodes(data) {
    return request.post('/osgbTree/v3/addLevelNodes', data);
}

// 获取节点列表
export function getOsgbNodeList(data) {
    return request.post('/osgbTree/v3/nodeList', data);
}

// 修改节点信息
export function modifyOsgbNodeName(data) {
    return request.put('/osgbTree/v3/updateNodeName', data);
}

// 数据集引用校验
export function osgbQuoteService(data) {
    return request.post('/osgbTree/v3/setCoordinatesCheck', data);
}

// 设置坐标系信息
export function setOsgbCoordinatesService(data) {
    return request.put('/osgbTree/v3/setCoordinates', data);
}

// 删除数据集校验
export function deleteOsgbDataSetCheckService(data) {
    return request.delete('/osgbTree/v3/deleteDataSets/check', { data });
}

// 删除节点
export function deleteOsgbNode(data) {
    return request.delete('/osgbTree/v3/deleteNodes', { data });
}

// 移动节点
export function moveOsgbNode(data) {
    return request.put('/osgbTree/v3/moveNodes', data);
}

// 获取倾斜摄影数据集下的文件列表
export function getOsgbDatasetFiles(data) {
    return request.post('/osgbTree/v3/file/list', data);
}

// 倾斜摄影数据预览生成缩略图
export function updateOsgbThumbnailService(data) {
    return request.post('/osgbTree/v3/updateThumbnail', data);
}

// 倾斜摄影文件上传校验
export function createOsgbInFolderCheckService(data) {
    return request.post('/osgbFile/v3/createInFolder/check', data);
}

// 创建文件上传
export function createOsgbFolderUpload(data) {
    return request.post('/osgbFile/v3/createInFolder', data);
}

// 暂停文件上传
export function pauseOsgbFile(data) {
    return request.post('/osgbFile/v3/pause', data);
}

// 批量暂停文件上传
export function batchPauseOsgbFile(data) {
    return request.post('/osgbFile/v3/batch/pause', data);
}

/**
 * 数据管理-360全景图
 */

// 根据项目id获取资源目录树
export function getPanoramaTreeService(data) {
    return request.post('/panoramaTree/v3/getById', data);
}

// 添加层级节点
export function addPanoramaLevelNodes(data) {
    return request.post('/panoramaTree/v3/addLevelNodes', data);
}

// 获取节点列表
export function getPanoramaNodeList(data) {
    return request.post('/panoramaTree/v3/nodeList', data);
}

// 修改节点信息
export function modifyPanoramaNodeName(data) {
    return request.put('/panoramaTree/v3/updateNodeName', data);
}

// 删除节点
export function deletePanoramaNode(data) {
    return request.delete('/panoramaTree/v3/deleteNodes', { data });
}

// 移动节点
export function movePanoramaNode(data) {
    return request.put('/panoramaTree/v3/moveNodes', data);
}

// 检验节点文件是否重名
export function checkPanoramaFileNameRepeats(data) {
    return request.post('/panoramaTree/v3/checkNameRepeats', data);
}

// 获取360全景图数据集下的文件列表
export function getPanoramaDatasetFiles(data) {
    return request.post('/panoramaTree/v3/file/list', data);
}

// 360全景图文件上传校验
export function createPanoramaInFolderCheckService(data) {
    return request.post('/panoramaFile/v3/createInFolder/check', data);
}

// 创建文件上传
export function createPanoramaFolderUpload(data) {
    return request.post('/panoramaFile/v3/createInFolder', data);
}

// 暂停文件上传
export function pausePanoramaFile(data) {
    return request.post('/panoramaFile/v3/pause', data);
}

// 批量暂停文件上传
export function batchPausePanoramaFile(data) {
    return request.post('/panoramaFile/v3/batch/pause', data);
}

// 360全景图提交转换
export function addPanoramaConvertQueue(data) {
    return request.post('/panoramaFile/v3/addToConvertQueue', data);
}

/**
 * 数据管理-点云
 */

// 根据项目id获取资源目录树
export function getPointCloudTreeService(data) {
    return request.post('/pointCloudTree/v3/getById', data);
}

// 添加层级节点
export function addPointCloudLevelNodes(data) {
    return request.post('/pointCloudTree/v3/addLevelNodes', data);
}

// 获取节点列表
export function getPointCloudNodeList(data) {
    return request.post('/pointCloudTree/v3/nodeList', data);
}

// 修改节点信息
export function modifyPointCloudNodeName(data) {
    return request.put('/pointCloudTree/v3/updateNodeName', data);
}

// 数据集引用校验
export function pointCloudQuoteService(data) {
    return request.post('/pointCloudTree/v3/setCoordinatesCheck', data);
}

// 设置坐标系信息
export function setPointCloudCoordinatesService(data) {
    return request.put('/pointCloudTree/v3/setCoordinates', data);
}

// 删除数据集校验
export function deletePointCloudDataSetCheckService(data) {
    return request.delete('/pointCloudTree/v3/deleteDataSets/check', { data });
}

// 删除节点
export function deletePointCloudNode(data) {
    return request.delete('/pointCloudTree/v3/deleteNodes', { data });
}

// 移动节点
export function movePointCloudNode(data) {
    return request.put('/pointCloudTree/v3/moveNodes', data);
}

// 获取点云数据集下的文件列表
export function getPointCloudDatasetFiles(data) {
    return request.post('/pointCloudTree/v3/file/list', data);
}

// 点云数据预览生成缩略图
export function updatePointCloudThumbnailService(data) {
    return request.post('/pointCloudTree/v3/updateThumbnail', data);
}

// 点云配置转换参数
export function pointCloudConvertConfigService(data) {
    return request.post('/pointCloudTree/v3/configConvert', data);
}

// 点云批量配置转换参数
export function pointCloudBatchConvertConfigService(data) {
    return request.post('/pointCloudTree/v3/batchConvertConfig', data);
}

// 点云文件上传校验
export function createPointCloudInFolderCheckService(data) {
    return request.post('/pointCloudFile/v3/createInFolder/check', data);
}

// 创建文件上传
export function createPointCloudFolderUpload(data) {
    return request.post('/pointCloudFile/v3/createInFolder', data);
}

// 暂停文件上传
export function pausePointCloudFile(data) {
    return request.post('/pointCloudFile/v3/pause', data);
}

// 批量暂停文件上传
export function batchPausePointCloudFile(data) {
    return request.post('/pointCloudFile/v3/batch/pause', data);
}

// 点云提交转换
export function addPointCloudConvertQueue(data) {
    return request.post('/pointCloudFile/v3/addToConvertQueue', data);
}

/**
 * 数据管理-二维图纸
 */

// 根据项目id获取资源目录树
export function getCadTreeService(data) {
    return request.post('/cadTree/v3/getById', data);
}

// 添加层级节点
export function addCadLevelNodes(data) {
    return request.post('/cadTree/v3/addLevelNodes', data);
}

// 获取节点列表
export function getCadNodeList(data) {
    return request.post('/cadTree/v3/nodeList', data);
}

// 修改节点信息
export function modifyCadNodeName(data) {
    return request.put('/cadTree/v3/updateNodeName', data);
}

// 数据集引用校验
export function cadQuoteService(data) {
    return request.post('/cadTree/v3/setCoordinatesCheck', data);
}

// 设置坐标系信息
export function setCadCoordinatesService(data) {
    return request.put('/cadTree/v3/setCoordinates', data);
}

// 删除数据集校验
export function deleteCadDataSetCheckService(data) {
    return request.delete('/cadTree/v3/deleteNodes/check', { data });
}

// 删除节点
export function deleteCadNode(data) {
    return request.delete('/cadTree/v3/deleteNodes', { data });
}

// 移动节点
export function moveCadNode(data) {
    return request.put('/cadTree/v3/moveNodes', data);
}

// Cad文件设置单位
export function setUnitService(data) {
    return request.put('/cadTree/v3/setUnit', data);
}

// 获取数据集下的文件列表
export function getCadDatasetFiles(data) {
    return request.post('/cadTree/v3/file/list', data);
}

// 二维图纸数据预览生成缩略图
export function updateCadThumbnailService(data) {
    return request.post('/cadTree/v3/updateThumbnail', data);
}

// 二维图纸文件上传校验
export function createCadInFolderCheckService(data) {
    return request.post('/cadFile/v3/createInFolder/check', data);
}

// 创建文件上传
export function createCadFolderUpload(data) {
    return request.post('/cadFile/v3/createInFolder', data);
}

// 暂停文件上传
export function pauseCadFile(data) {
    return request.post('/cadFile/v3/pause', data);
}

// 批量暂停文件上传
export function batchPauseCadFile(data) {
    return request.post('/cadFile/v3/batch/pause', data);
}

// 二维图纸提交转换
export function submitCadConvertService(data) {
    return request.post('/cadFile/v3/addToConvertQueue', data);
}

/**
 * 数据管理-矢量数据
 */

// 根据项目id获取资源目录树
export function getVectorTreeService(data) {
    return request.post('/vectorTree/v3/getById', data);
}

// 添加层级节点
export function addVectorNodeService(data) {
    return request.post('/vectorTree/v3/addLevelNodes', data);
}

// 获取节点列表
export function getVectorNodeListService(data) {
    return request.post('/vectorTree/v3/nodeList', data);
}

// 修改节点信息
export function modifyVectorNodeNameService(data) {
    return request.put('/vectorTree/v3/updateNodeName', data);
}

// 删除数据集校验
export function deleteVectorDataSetCheckService(data) {
    return request.delete('/vectorTree/v3/deleteDataSets/check', { data });
}

// 删除节点
export function deleteVectorNodeService(data) {
    return request.delete('/vectorTree/v3/deleteNodes', { data });
}

// 移动节点
export function moveVectorNodeService(data) {
    return request.put('/vectorTree/v3/moveNodes', data);
}

// 矢量数据预览生成缩略图
export function updateVectorThumbnailService(data) {
    return request.post('/vectorTree/v3/updateThumbnail', data);
}

// 获取数据集下的文件列表
export function getVectorDatasetFilesServices(data) {
    return request.post('/vectorFile/v3/file/list', data);
}

// 矢量数据文件上传校验
export function createVectorInFolderCheckService(data) {
    return request.post('/vectorFile/v3/createInFolder/check', data);
}

// 创建文件上传
export function createVectorFolderUploadService(data) {
    return request.post('/vectorFile/v3/createInFolder', data);
}

// 暂停文件上传
export function pauseVectorFileService(data) {
    return request.post('/vectorFile/v3/pause', data);
}

// 批量暂停文件上传
export function batchPauseCadFileService(data) {
    return request.post('/vectorFile/v3/batch/pause', data);
}

// 获取矢量切片精度
export function getVectorLodConfigService(data) {
    return request.post('/vectorFile/v3/getLodConfig', data);
}

// 设置矢量切片精度
export function saveVectorLodConfigService(data) {
    return request.post('/vectorFile/v3/saveLodConfig', data);
}

// 矢量数据提交转换
export function submitVectorConvertService(data) {
    return request.post('/vectorFile/v3/addToConvertQueue', data);
}

// 获取矢量属性信息
export function getVectorAttrService(data) {
    return request.post('/element/v3/getVectorParam', data);
}

/**
 * 场景管理-单项目场景目录树
 */

// 创建根节点
export function createSingleSceneTreeRoot(data) {
    return request.post('/sceneTree/v3/addRoot', data);
}

// 添加文件夹节点
export function addSceneDirNodeService(data) {
    return request.post('/sceneTree/v3/addDirNode', data);
}

// 添加节点
export function addSceneDatasetTreeNode(data) {
    return request.post('/sceneTree/v3/addDataSetNodes', data);
}

// 获取模型文件数据
export function getSceneBimTreeService(data) {
    return request.post('/scene/v3/getBimTree', data);
}

// 获取倾斜摄影数据
export function getSceneOsgbTreeService(data) {
    return request.post('/scene/v3/getOsgbTree', data);
}

// 获取点云数据
export function getScenePointCloudTreeService(data) {
    return request.post('/scene/v3/getPointCloudTree', data);
}

// 获取遥感数据
export function getSceneRsTreeService(data) {
    return request.post('/scene/v3/getRsTree', data);
}

// 获取Wmts数据
export function getSceneWmtsTreeService(data) {
    return request.post('/scene/v3/getWmtsTree', data);
}

// 获取矢量瓦片数据
export function getSceneVectorTreeService(data) {
    return request.post('/scene/v3/getVectorTree', data);
}

// 获取Cad瓦片数据
export function getSceneCadTreeService(data) {
    return request.post('/scene/v3/getCadTree', data);
}

// 添加数据集至场景
export function addDataSetToSceneService(data) {
    return request.post('/sceneTree/v3/addDataSetNodes', data);
}

// 修改节点
export function motifySceneDataSetTreeNode(data) {
    return request.put('/sceneTree/v3/updateNode', data);
}

// 移动节点
export function dataSetTreeNodeMoveService(data) {
    return request.put('/sceneTree/v3/moveTo', data);
}

// 删除节点
export function deleteSingleSceneTreeNode(data) {
    return request.delete('/sceneTree/v3/deleteNodes', { data });
}

// 获取GIS数据优先级
export function getGisPriorityListService(treeNodeId) {
    return request.get(`/sceneTree/v3/getGisPriorityList/${treeNodeId}`);
}

// 更新GIS数据优先级
export function updateGisPriorityListService(data) {
    return request.put('/sceneTree/v3/updateGisPriorityList', data);
}

// 获取场景矢量数据配置
export function getSceneVectorConfigService(treeNodeId) {
    return request.get(`/sceneTree/v3/getSceneVectorConfig/${treeNodeId}`);
}

// 更新场景矢量数据配置
export function updateSceneVectorConfigService(data) {
    return request.put('/sceneTree/v3/updateSceneVectorConfig', data);
}

// 获取场景二维图纸配置
export function getSceneCadConfigService(treeNodeId) {
    return request.get(`/sceneTree/v3/getSceneCadConfig/${treeNodeId}`);
}

// 更新场景二维图纸配置
export function updateSceneCadConfigService(data) {
    return request.put('/sceneTree/v3/updateSceneCadConfig', data);
}

// 根据ID查询树
export function getSingleSceneTreeById(data) {
    return request.post('/sceneTree/v3/getTreeById', data);
}

// 根据数据集id查询文件
export function getDastasetFiles(data) {
    return request.post('/sceneTree/v3/node/getOutLine', data);
}

// 场景公共构件列表
export function getPublicElemList(data) {
    return request.post('/scene/v3/publicComponents', data);
}

// 场景我的构件列表
export function getPrivateElemList(data) {
    return request.post('/scene/v3/privateComponents', data);
}

// 创建单构件目录树根节点
export function createElemTreeRoot(data) {
    return request.post('/sceneTree/componentTree/v3/addRoot', data);
}

// 根据ID查询树
export function getComponentTreeService(data) {
    return request.post('/sceneTree/componentTree/v3/getTreeById', data);
}

// 添加单构件目录树子节点
export function addElemTreeNode(data) {
    return request.post('/sceneTree/componentTree/v3/addNode', data);
}

// 更改单构件目录树节点
export function motifyElemTreeNode(data) {
    return request.post('/sceneTree/componentTree/v3/updateNodeName', data);
}

// 获取构件文件属性
export function getElemInfo(data) {
    return request.post('/sceneTree/componentTree/v3/getComponentFileInfo', data);
}

// 查询构件属性
export function getElemParamService(data) {
    return request.post('/componentLibrary/v3/getComponentProperty', data);
}

// 查询构件属性类型
export function getElemParamTypeService(data) {
    return request.post('/componentLibrary/v3/getComponentParamTypes', data);
}

// 删除单构件目录树节点
export function deleteElemTreeNode(data) {
    return request.delete('/sceneTree/componentTree/v3/deleteNodes', { data });
}

// 更改单构件动画播放状态
export function motifyElemAnimState(data) {
    return request.post('/sceneTree/componentTree/v3/updateAnimationStatus', data);
}

// 更改单构件动画播放模式
export function motifyElemAnimMode(data) {
    return request.post('/sceneTree/componentTree/v3/updateAnimationPlayMode', data);
}

/**
 * 场景管理-场景的增删改查
 */

export function createSceneService(data) {
    return request.post('/scene/v3/create', data);
}

export function modifySceneService(data) {
    return request.put('/scene/v3/update', data);
}

// 获取场景异常数据列表
export function getExceptionListService(data) {
    return request.get('/scene/v3/getExceptionDataList', data);
}

// 场景矢量转换失败重试
export function vectorRetryService(treeNodeId) {
    return request.put(`/scene/v3/vectorConvertRetry?treeNodeId=${treeNodeId}`);
}

// 场景Cad转换失败重试
export function cadRetryService(treeNodeId) {
    return request.put(`/scene/v3/cadConvertRetry?treeNodeId=${treeNodeId}`);
}

// 发布场景
export function publishSceneService(data) {
    return request.put('/scene/v3/publish', data);
}

// 场景获取转换队列
export function getSceneConvertQueueService(data) {
    return request.post('/convertQueue/v3/getSceneConvertQueue', data);
}

// 场景发布状态
export function getScenePublishStatus(data) {
    return request.post('/dataSet/v3/getSceneConvertStatus', data);
}

// 场景发布进度
export function getScenePublishProgress(data) {
    return request.post('/dataSet/v3/getSceneConvertingProgress', data);
}

export function deleteSceneService(data) {
    return request.delete('/scene/v3/delete', { data });
}

export function batchDeleteSceneService(data) {
    return request.delete('/scene/v3/batchDelete', { data });
}

export function setDefaultViewService(data) {
    return request.put('/scene/v3/setDefault', data);
}

export function copySceneService(data) {
    return request.put('/scene/v3/duplicate', data);
}

export function getSceneListService(data) {
    return request.post('/scene/v3/list', data);
}

export function getSceneById(sceneId) {
    return request.get(`/scene/v3/${sceneId}`);
}

// 获取场景概要信息
export function getSceneSummaryService(sceneId) {
    return request.get(`/scene/v3/scenesummary?sceneId=${sceneId}`);
}

// 查询场景的位置信息
export function getSceneOffset(data) {
    return request.get('/scene/v3/sceneoffset', data);
}

// 保存场景中数据集的位置信息
export function saveSceneOffset(data) {
    return request.put('/scene/v3/editPosition', data);
}

// 初始化位置信息
export function initScenePosService(sceneId) {
    return request.put(`/scene/v3/initLocation/${sceneId}`);
}

/**
 * 水面
 */

// 获取水面颜色列表
export function getWaterColorsService() {
    return request.get('/sceneTree/v3/getSceneWaterColors');
}

// 创建水面
export function createWaterService(data) {
    return request.post('/sceneTree/v3/water/create', data);
}

// 编辑水面
export function editWaterService(data) {
    return request.post('/sceneTree/v3/water/edit', data);
}

/**
 * 开挖
 */

// 获取开挖纹理列表
export function getExtrudeTexturesService() {
    return request.get('/sceneTree/v3/getSceneExcavateIntrinsicTextureImages');
}

// 创建开挖
export function createExtrudeService(data) {
    return request.post('/sceneTree/v3/excavate/create', data);
}

// 编辑开挖
export function editExtrudeService(data) {
    return request.post('/sceneTree/v3/excavate/edit', data);
}

/**
 * 我的分享
 */

// 创建场景分享
export function createSceneShare(data) {
    return request.post('/share/v3/scene/create', data);
}

// 创建Bim数据集分享
export function createBimShare(data) {
    return request.post('/share/v3/dataset/bim/create', data);
}

// 创建Rs数据集分享
export function createRsShare(data) {
    return request.post('/share/v3/dataset/rs/create', data);
}

// 创建Wmts数据集分享
export function createWmtsShare(data) {
    return request.post('/share/v3/dataset/wmts/create', data);
}

// 创建倾斜摄影数据集分享
export function createOsgbShare(data) {
    return request.post('/share/v3/dataset/osgb/create', data);
}

// 创建360全景图数据集分享
export function createPanoramaShare(data) {
    return request.post('/share/v3/dataset/panorama/create', data);
}

// 创建点云数据集分享
export function createPointCloudShare(data) {
    return request.post('/share/v3/dataset/pointCloud/create', data);
}

// 创建二维图纸数据集分享
export function createCadShare(data) {
    return request.post('/share/v3/dataset/cad/create', data);
}

// 创建矢量数据集分享
export function createVectorShare(data) {
    return request.post('/share/v3/dataset/vector/create', data);
}

// 生成UserId cookie
export function generateUser(data) {
    return request.post('/share/v3/generateUserCookie', data);
}

// 取消分享
export function cancelShareService(data) {
    return request.put('/share/v3/cancel', data);
}

// 项目内部取消分享
export function cancelSingleProjectShareService(data) {
    return request.put('/share/v3/singleProject/cancel', data);
}

// 移除他人分享
export function removeOtherShareService(data) {
    return request.put('/share/v3/shareToMe/cancel', data);
}

// 根据条件查询分享列表
export function qureyShareListService(data) {
    return request.post('/share/v3/list', data);
}

// 根据项目Id查询分享列表
export function qureyShareListByProjId(projId, data) {
    return request.post(`/share/v3/${projId}/list`, data);
}

// 根据条件查询被分享列表
export function qureyShareToMeListService(data) {
    return request.post('/share/v3/shareToMe/list', data);
}

// 根据条件查询被分享列表--未对接
export function qureySharedProjectService(projId) {
    return request.post(`/v3/sharedProject/${projId}`);
}

/**
 * 基础数据-用户管理
 */

// 获取用户列表
export function getUserList(data) {
    return basicRequest.post('/user/list', data);
}

// 获取用户名称列表
export function getUserNameList(data) {
    return basicRequest.post('/user/userNameList', data);
}

// 根据条件查询用户
export function findUserService(data) {
    return basicRequest.post('/user/findUser', data);
}

// 新增用户
export function addUser(data) {
    return basicRequest.post('/user/create', data);
}

// 编辑用户
export function modifyUser(data) {
    return basicRequest.put('/user/update', data);
}

// 修改用户密码
export function modifyUserPassword(data) {
    return basicRequest.put('/user/changePassword', data);
}

// 删除用户校验-子级用户校验
export function deleteUserCheckTeamService(data) {
    return basicRequest.delete('/user/delete/checkTeam', { data });
}

// 删除用户校验-关联项目校验
export function deleteUserCheckProjService(data) {
    return basicRequest.delete('/user/delete/checkUserProject', { data });
}

// 批量删除用户校验-子级用户校验
export function batchDeleteUserCheckTeamService(data) {
    return basicRequest.delete('/user/batchDelete/checkTeam', { data });
}

// 批量删除用户校验-关联项目校验
export function batchDeleteUserCheckProjService(data) {
    return basicRequest.delete('/user/batchDelete/checkUserProject', { data });
}

// 删除用户
export function deleteUserService(data) {
    return basicRequest.delete('/user/delete', { data });
}

// 批量删除用户
export function batchDeleteUserService(data) {
    return basicRequest.delete('/user/batchDelete', { data });
}

// 获取可分配角色列表
export function getUserRoleList(data) {
    return basicRequest.post('/role/AssignableRoleList', data);
}

// 分配角色
export function assignRoles(data) {
    return basicRequest.put('/user/updateRole', data);
}

// 用户中心获取个人信息
export function getUserInfoByCenter(headers) {
    return basicRequest.get('/user/getUserByCenter', { headers });
}

// 获取可选择的用户列表
export function getOptionalUserListService(data) {
    return basicRequest.post('/user/UserRelation/OptionalUserList', data);
}

// 获取指定用户的关系列表
export function getUserRelationListService(data) {
    return basicRequest.post('/user/UserRelation/List', data);
}

// 获取未绑定的用户列表
export function getUnBindUserListService(data) {
    return basicRequest.post('/user/UserRelation/UnBindUserList', data);
}

// 创建用户关联关系
export function createUserRelationService(data) {
    return basicRequest.put('/user/UserRelation/Add', data);
}

// 删除用户关联检查
export function delUserRelationCheckService(data) {
    return basicRequest.delete('/user/UserRelation/Delete/Check', { data });
}

// 删除用户关联关系
export function deleteUserRelationService(userId) {
    return basicRequest.delete(`/user/UserRelation/Delete/${userId}`);
}

// 批量删除用户关联关系
export function batchDeleteUserRelationService(data) {
    return basicRequest.delete('/user/UserRelation/BatchDelete', { data });
}
/**
 * 基础数据-角色管理
 */

// 获取角色列表
export function getRoleListService(data) {
    return basicRequest.post('/role/list', data);
}

// 创建角色
export function createRoleService(data) {
    return basicRequest.post('/role/create', data);
}

// 获取角色级别列表
export function getRoleLevelListService() {
    return basicRequest.get('/role/AssignableRoleLevelList');
}

// 获取角色范围列表
export function getRoleScopeListService() {
    return basicRequest.get('/role/AssignableRoleScopeList');
}

// 获取用户范围列表
export function getUserScopeListService() {
    return basicRequest.get('/role/AssignableUserScopeList');
}

// 获取项目范围列表
export function getProjScopeListService() {
    return basicRequest.get('/role/AssignableProjectScopeList');
}

// 更新角色
export function updateRoleService(data) {
    return basicRequest.put('/role/update', data);
}

// 删除角色
export function deleteRoleCheckService(data) {
    return basicRequest.delete('/role/deleteCheck', { data });
}

// 删除角色
export function deleteRoleService(roleId) {
    return basicRequest.delete(`/role/delete/${roleId}`);
}

// 批量删除角色
export function batchDeleteRoleService(data) {
    return basicRequest.delete('/role/batchDelete', data);
}

/**
 * 基础数据-权限管理
 */

// 创建页面菜单
export function createPage(data) {
    return basicRequest.post('/permission/createPage', data);
}

// 创建模块菜单
export function createModule(data) {
    return basicRequest.post('/permission/createModule', data);
}

// 创建功能菜单
export function createFeature(data) {
    return basicRequest.post('/permission/createFeature', data);
}

// 更新页面菜单
export function modifyPage(data) {
    return basicRequest.put('/permission/updatePage', data);
}

// 更新模块菜单
export function modifyModule(data) {
    return basicRequest.put('/permission/updateModule', data);
}

// 更新功能菜单
export function modifyFeature(data) {
    return basicRequest.put('/permission/updateFeature', data);
}

// 删除菜单
export function deletePermissionService(data) {
    return basicRequest.delete('/permission/delete', { data });
}

// 角色授权
export function grantRole(data) {
    return basicRequest.put('/permission/roleGrant', data);
}

// 权限菜单
export function getPermissionMenu(data) {
    return basicRequest.post('/permission/grantPermissionMenu', data);
}

// 权限菜单
export function getRoleMenu(data, headers) {
    return basicRequest.post('/permission/roleMenu', data, headers);
}

// 获取子权限列表
export function getSubPermissionMenu(parentId) {
    return basicRequest.get(`/permission/subMenuDetails/${parentId}`);
}

/**
 * Client认证
 */

// 新增Client
export function createClient(data) {
    return basicRequest.post('/customAuth/create', data);
}

// 更新Client
export function updateClient(data) {
    return basicRequest.put('/customAuth/update', data);
}

// 删除Client
export function deleteClient(clientId) {
    return basicRequest.delete(`/customAuth/delete/${clientId}`);
}

// 获取Client列表
export function getClientList(data) {
    return basicRequest.post('/customAuth/list', data);
}

/**
 * 工程相关服务器控制
 */

// 获取工程状态
export function getProjectStatus(data) {
    return request.post('/dataSet/v3/getConvertStatus', data);
}

// 批量获取数据集转换状态
export function batchGetProjectStatusService(data) {
    return request.post('/dataSet/v3/batchGetConvertStatus', data);
}

// 查询转换中工程进度
export function getProjectConvertingProgress(data) {
    return request.post('/dataSet/v3/getConvertingProgress', data);
}

// 批量查询转换中工程进度
export function getProjectsConvertingProgress(data) {
    return request.post('/dataSet/v3/convertingProgressList', data);
}

// 请求转换队列
export function getConvertingQueue(data) {
    return request.post('/convertQueue/v3/getConvertQueue', data);
}

// 停止正在转换中的工程
export function stopConvertingProject(data) {
    return request.post('/convertQueue/v3/stopConvertingQueue', data);
}

// 置顶转换队列
export function topUpQueueService(data) {
    return request.post('/convertQueue/v3/topConvertQueue', data);
}

// 移动转换队列
export function moveConvertQueue(data) {
    return request.post('/convertQueue/v3/moveConvertQueue', data);
}

// 删除转换队列
export function delQueueProject(data) {
    return request.post('/convertQueue/v3/removeConvertQueue', data);
}

// 批量请求队列取消
export function batchRemoveConvertQueueService(data) {
    return request.post('/convertQueue/v3/batchRemoveConvertQueue', data);
}

// 获取工程信息模型
export function getDataSetResService(data) {
    return request.post('/dataSet/v3/viewDataSetModel', data);
}

// 请求模型目录树
export function getProjectTree(data) {
    return request.post('/dataSet/v3/dataSetRootNodes', data);
}

// 请求模型目录树子节点
export function getProjectTreeSubNodes(data) {
    return request.post('/dataSet/v3/dataSetFileTreeNodes', data);
}

// 请求模型目录树子节点
export function getProjectTreeSubNodesByLazy(data) {
    return request.post('/dataSet/v3/dataSetFileTreeNodes/lazy', data);
}

// 根据分组获取目录树子节点
export function getBimElemTreeNodesByGroupService(data) {
    return request.post('/dataSet/v3/rvtGroupTreeNodes', data);
}

// 请求模型目录树下的构件ID
export function getProjectTreeChildren(data) {
    return request.post('/element/v3/getTreeChildren', data);
}

// 请求模型目录树下的构件ID
export function getProjectTreeChildrenByLazy(data) {
    return request.post('/element/v3/getTreeChildren/lazy', data);
}

// 获取RvtGroup节点关联的构件id
export function getBimElemIdsByGroupService(data) {
    return request.post('/element/v3/getRvtGroupTreeChildren', data);
}

// 查询RvtGroup分组属性
export function getRvtGroupAttrService(data) {
    return request.post('/element/v3/getRvtGroupParam', data);
}

// 根据构件查询RvtGroup分组
export function getRvtGroupByElemIdService(data) {
    return request.post('/element/v3/getRvtGroupByElem', data);
}

// 查询模型属性
export function getProjectParam(data) {
    return request.post('/element/v3/getElementParam', data);
}

// 根据构件id查询目录树路径
export function getElemTreePath(data) {
    return request.post('/element/v3/getElementTreePath', data);
}

// 获取全局配置信息
export function getGlobalServerConfig(data) {
    return request.post('/system/getGlobalServerConfig', data);
}

// 设置全局配置信息
export function setGlobalServerConfig(data) {
    return request.post('/system/setGlobalServerConfig', data);
}

/**
 * 分享页面相关接口
 */

// 根据查询条件查询场景
export function getSharedSceneById(sceneId, headers) {
    return sharedRequest.get(`/scene/v3/${sceneId}`, headers);
}

// 根据树id查询树
export function getSharedProjectSceneTree(data, headers) {
    return sharedRequest.post('sceneTree/v3/getTreeById', data, headers);
}

// 根据树id查询构件树
export function getSharedElemTreeService(data, headers) {
    return sharedRequest.post('/sceneTree/componentTree/v3/getTreeById', data, headers);
}

// 获取数据集模型
export function getSharedProjectModel(data, headers) {
    return sharedRequest.post('/dataSet/v3/viewDatasetModel', data, headers);
}

// 是否具有空间信息
export function isSharedRoomExistService(data, headers) {
    return sharedRequest.post('/engine/v3/room/exists', data, headers);
}

// 是否具有图纸信息
export function isSharedCadMapExistService(data, headers) {
    return sharedRequest.post('/engine/v3/cadmap/exists', data, headers);
}

// 是否具有图纸信息
export function getSharedRoomList(data, headers) {
    return sharedRequest.post('/engine/v3/room/list', data, headers);
}

// 获取数据集下的Cad文件列表
export function getSharedCadDatasetFiles(data, headers) {
    return sharedRequest.post('/cadTree/v3/file/list', data, headers);
}

// 获取房间信息
export function getSharedRoomInfo(data, headers) {
    return sharedRequest.post('/engine/v3/room/element/parameter/list', data, headers);
}

// 获取房间构件
export function getSharedRoomElement(data, headers) {
    return sharedRequest.post('/element/v3/getRoomTreeChildren', data, headers);
}

// 获取二维图纸列表
export function getSharedCadMapList(data, headers) {
    return sharedRequest.post('/engine/v3/cadMap/list', data, headers);
}

// 根据构件id获取图纸元素id
export function getSharedCadIdByElemId(data, headers) {
    return sharedRequest.post('/engine/v3/cadMap/cadId/byElementId', data, headers);
}

// 根据图纸元素id获取构件id
export function getSharedElemIdByCadId(data, headers) {
    return sharedRequest.post('/engine/v3/cadMap/byElementId/byCadId', data, headers);
}

// 获取树目录
export function getSharedProjectTree(data, headers) {
    return sharedRequest.post('/dataSet/v3/dataSetRootNodes', data, headers);
}

// 请求模型目录树子节点
export function getSharedProjectTreeSubNodesByLazy(data, headers) {
    return sharedRequest.post('/dataSet/v3/dataSetFileTreeNodes/lazy', data, headers);
}

// 请求模型目录树下的构件ID
export function getSharedProjectTreeChildrenByLazy(data, headers) {
    return sharedRequest.post('/element/v3/getTreeChildren/lazy', data, headers);
}

// 根据树节点id获取构件集id
export function getSharedProjectTreeChildren(data, headers) {
    return sharedRequest.post('/element/v3/getTreeChildren', data, headers);
}

// 根据构件id查询属性
export function getSharedProjectParam(data, headers) {
    return sharedRequest.post('/element/v3/getElementParam', data, headers);
}

// 根据构件id查询矢量属性
export function getSharedVectorParam(data, headers) {
    return sharedRequest.post('/element/v3/getVectorParam', data, headers);
}

// 请求模型目录树子节点
export function getSharedProjectTreeSubNodes(data, headers) {
    return sharedRequest.post('/dataSet/v3/dataSetFileTreeNodes', data, headers);
}

// 分享被读取
export function shareRead(data, headers) {
    return sharedRequest.post('/share/v3/read', data, headers);
}

// 查询分享场景偏移信息
export function getSharedSceneOffset(data) {
    return sharedRequest.get('/scene/v3/sceneoffset', data);
}

// 分享查看界面获取开挖纹理列表
export function getSharedExtrudeTexturesList(headers) {
    return sharedRequest.get('/sceneTree/v3/getSceneExcavateIntrinsicTextureImages', headers);
}

/**
 * 商业化配置相关-Sass服务配置
 */

// 获取用户配置信息
export function getSassConfigInfo(data) {
    return request.get(`/sysInitialize/user/${data}`);
}

// 添加Sass配置
export function createSassConfig(data) {
    return request.post('/sysInitialize/createPaas', data);
}

// 更新Sass配置
export function modifySassConfig(data) {
    return request.post('/sysInitialize/updatePaas', data);
}

// 获取已有的客户
export function getPrivateExistingCustomers() {
    return request.get('/sysInitialize/customer/list');
}

// 根据客户ID获取客户配置信息
export function getPrivateConfigInfo(data) {
    return request.get(`/sysInitialize/customer/get/${data}`);
}

// 添加私有化配置
export function createPrivateConfig(data) {
    return request.post('/sysInitialize/createPrivate', data);
}

// 更新私有化配置客户信息
export function modifyPrivateCustomer(data) {
    return request.put('/sysInitialize/updateCustomer', data);
}

// 更新私有化配置
export function modifyPrivateConfig(data) {
    return request.put('/sysInitialize/updatePrivate', data);
}

// 删除私有化配置
export function deletePrivateConfig(data) {
    return request.delete('/sysInitialize/deletePrivate', { data });
}

// 获取私有化部署License文件
export function downloadPrivateConfigFile(id, data) {
    return request.get(`/sysInitialize/fileDownload/${id}`, data);
}

/**
 * 数据迁移相关接口
 */

// 一键导出项目
export function exportProjService(data) {
    return request.post('/dataSetMigration/v3/export/byProject', data);
}

// 一键导出校验
export function exportProjCheckService(data) {
    return request.post('/dataSetMigration/v3/export/byProject/check', data);
}

// 获取目标项目列表项目
export function getExportOptionalProjListService(data) {
    return request.post('/dataSetMigration/v3/export/OptionalProjectList', data);
}

// 导出项目
export function exportProjectService(data) {
    return request.post('/dataSetMigration/v3/export/project', data);
}

// 导出数据集
export function exportDatasetService(data) {
    return request.post('/dataSetMigration/v3/export/dataset', data);
}

// 导出数据集校验
export function exportDatasetCheckService(data) {
    return request.post('/dataSetMigration/v3/export/dataset/check', data);
}

// 导出场景
export function exportSceneService(data) {
    return request.post('/dataSetMigration/v3/export/scene', data);
}

// 导出场景校验
export function exportSceneCheckService(data) {
    return request.post('/dataSetMigration/v3/export/scene/check', data);
}

// 获取导出列表
export function getExportListService(data) {
    return request.post('/dataSetMigration/v3/export/list', data);
}

// 删除导出数据
export function deleteExport(dataId) {
    return request.delete(`/dataSetMigration/v3/export/delete/${dataId}`);
}

// 批量删除导出数据
export function batchDeleteExport(data) {
    return request.delete('/dataSetMigration/v3/export/batchDelete', { data });
}

// 重新导出
export function reExportService(dataId) {
    return request.post(`/dataSetMigration/v3/export/repeat/${dataId}`);
}

// 发布列表
export function publishListService(data) {
    return request.post('/dataSetMigration/v3/publish/list', data);
}

// 发布平台列表
export function platformsService(data) {
    return request.post('/dataSetMigration/v3/publish/getPlatforms', data);
}

// 发布平台列表
export function platformListService(data) {
    return request.post('/dataSetMigration/v3/platform/list', data);
}

// 新增发布平台
export function addPlatformService(data) {
    return request.post('/dataSetMigration/v3/platform', data);
}

// 删除发布平台
export function deletePlatformService(dataId) {
    return request.delete(`/dataSetMigration/v3/platform/${dataId}`);
}

// 启用发布平台
export function enablePlatformService(dataId) {
    return request.put(`/dataSetMigration/v3/platform/enable/${dataId}`);
}

// 禁用发布平台
export function disablePlatformService(dataId) {
    return request.put(`/dataSetMigration/v3/platform/disable/${dataId}`);
}

// 发布平台用户列表
export function platformsUserListService(data) {
    return request.post('/dataSetMigration/v3/publish/getUsers', data);
}

// 发布平台项目列表
export function platformsProjListService(data) {
    return request.post('/dataSetMigration/v3/publish/getProjects', data);
}

// 获取文件夹列表
export function platformsProjFolderService(data) {
    return request.post('/dataSetMigration/v3/publish/getDataSetDirTree', data);
}

// 导出发布
export function publishService(data) {
    return request.post('/dataSetMigration/v3/publish', data);
}

// 批量发布
export function batchPublishService(data) {
    return request.post('/dataSetMigration/v3/publish/batch', data);
}

// 发布校验
export function publishCheckService(data) {
    return request.post('/dataSetMigration/v3/publish/batch/check', data);
}

// 发布删除
export function publishDelService(id) {
    return request.delete(`/dataSetMigration/v3/publish/delete/${id}`);
}

// 发布批量删除
export function publishBatchDelService(data) {
    return request.delete('/dataSetMigration/v3/publish/batchDelete', data);
}

// 重新发布
export function rePublishService(publishId) {
    return request.put(`/dataSetMigration/v3/publish/repeat/${publishId}`);
}

// 获取项目所属人列表
export function getProjOwnerListService(data) {
    return request.post('/dataSetMigration/v3/Import/GetProjectOwnerList', data);
}

// 获取发布平台用户列表
export function getOwnersService(data) {
    return request.get('/dataSetMigration/v3/import/project/getOwners', data);
}

// 项目导入校验
export function projImportCheckService(data) {
    return request.post('/dataSetMigration/v3/import/project/check', data);
}

// 数据集导入校验
export function dataSetImportCheckService(data) {
    return request.post('/dataSetMigration/v3/import/dataset/check', data);
}

// 场景导入校验
export function sceneImportCheckService(data) {
    return request.post('/dataSetMigration/v3/import/scene/check', data);
}

// 创建导入文件
export function createImport(data, headers) {
    return request.post('/dataSetMigration/v3/import/create', data, headers);
}

// 暂停导入文件
export function pauseImportService(data) {
    return request.post('/dataSetMigration/v3/import/pause', data);
}

// 导入上传列表
export function importUploadListService(data) {
    return request.post('/dataSetMigration/v3/import/upload/list', data);
}

// 获取导入列表
export function getImportListService(data) {
    return request.post('/dataSetMigration/v3/import/list', data);
}

// 删除导入数据
export function deleteImport(dataId) {
    return request.delete(`/dataSetMigration/v3/import/delete/${dataId}`);
}

// 批量删除导入数据
export function batchDeleteImport(data) {
    return request.delete('/dataSetMigration/v3/import/batchDelete', { data });
}

// 获取文件夹列表
export function getImportFolderService(data) {
    return request.post('/dataSetMigration/v3/import/getDataSetDirTree', data);
}

// 纹理动画相关接口
export function getTextureList(data) {
    return request.post('/dataSet/v3/texture/list', data);
}

export function createTextureService(data) {
    return request.post('/dataSet/v3/texture/create', data);
}

export function updateTextureSrevice(data) {
    return request.post('/dataSet/v3/texture/update', data);
}

export function deleteTextureSrevice(data) {
    return request.post('/dataSet/v3/texture/delete', data);
}

export function textureEffectSrevice(data) {
    return request.post('/dataSet/v3/texture/effect', data);
}

export function updateTextureName(data) {
    return request.post('/dataSet/v3/texture/updateName', data);
}

export function isUpgradeService(data) {
    return request.post('/dataSet/v3/isTemplateNeedUpgrade', data);
}

export function applyTextureService(data) {
    return request.post('/dataSet/v3/applyTextures', data);
}

export function applyTextureQueueService(data) {
    return request.post('/dataSet/v3/applyTexturesQueue', data);
}

export function getTextureStatusService(data) {
    return request.post('/dataSet/v3/getTextureConvertStatus', data);
}

export function getTextureProgressService(data) {
    return request.post('/dataSet/v3/getTextureConvertingProgressList', data);
}

export function getSharedTextureList(data, headers) {
    return sharedRequest.post('/dataSet/v3/texture/list', data, headers);
}

/**
 * 构件库管理接口
 */

// 批量构件转换状态
export function getElemConvertStatus(data) {
    return request.post('/dataSet/v3/getComponentConvertStatus', data);
}

// 批量查询转换中构件进度
export function getElemsConvertingProgress(data) {
    return request.post('/dataSet/v3/getComponentConvertingProgressList', data);
}

// 公共构件-移动转换队列
export function moveClPublicConvertQueue(data) {
    return request.post('/convertQueue/v3/moveClPublicConvertQueue', data);
}

//  我的构件-移动转换队列
export function moveClPrivateConvertQueue(data) {
    return request.post('/convertQueue/v3/moveClPrivateConvertQueue', data);
}

// 公共构件-重名校验
export function publicElemCheckNameService(data) {
    return request.post('/componentLibrary/v3/public/checkNodeNames', data);
}

// 公共构件-上传
export function publicElemCreateUploadService(data, headers) {
    return request.post('/componentLibrary/v3/public/create', data, headers);
}

// 公共构件-暂停上传
export function publicElemPauseUploadService(data, headers) {
    return request.post('/componentLibrary/v3/public/pause', data, headers);
}

// 公共构件-批量暂停上传
export function publicElemBatchPauseUploadService(data) {
    return request.post('/componentLibrary/v3/public/batchPause', data);
}

// 公共构件-文件列表
export function publicElemFileListService(data) {
    return request.post('/componentLibrary/v3/public/fileList', data);
}

// 公共构件-转换队列
export function publicElemQueueService() {
    return request.post('/convertQueue/v3/getClPublicConvertQueue');
}

// 公共构件-创建分组
export function publicElemAddLevelNodeService(data) {
    return request.post('/componentLibrary/v3/public/addLevelNode', data);
}

// 公共构件-删除分组
export function publicElemDeleteLevelNodeService(data) {
    return request.post('/componentLibrary/v3/public/deleteLevelNode', data);
}

// 公共构件-更改分组名称
export function publicElemUpdateNodeNameService(data) {
    return request.post('/componentLibrary/v3/public/updateNodeName', data);
}

// 公共构件-移动分组
export function publicElemMoveNodeService(data) {
    return request.post('/componentLibrary/v3/public/move', data);
}

// 公共构件-批量移动分组
export function publicElemBatchMoveNodeService(data) {
    return request.post('/componentLibrary/v3/public/batchMove', data);
}

// 公共构件-目录树
export function publicElemCatalogService(data) {
    return request.post('/componentLibrary/v3/public/getTree', data);
}

// 公共构件-构件列表
export function publicElemListService(data) {
    return request.post('/componentLibrary/v3/public/list', data);
}

// 公共构件-删除构件
export function publicElemDeleteService(fileId) {
    return request.post(`/componentLibrary/v3/public/delete/${fileId}`);
}

// 公共构件-批量删除构件
export function publicElemBatchDeleteService(data) {
    return request.post('/componentLibrary/v3/public/delete', data);
}

// 公共构件-上传缩略图
export function uploadPublicElemThumbnailService(data) {
    return request.post('/componentLibrary/v3/public/clThumbnail/upload', data);
}

// 公共构件-更改缩略图
export function publicElemChangeThumbnailService(data) {
    return request.post('/componentLibrary/v3/public/changeThumbnail', data);
}

// 公共构件-缩略图列表
export function publicElemThumbnailListService(fileId) {
    return request.post(`/componentLibrary/v3/public/thumbnails/${fileId}`);
}

// 公共构件-收藏/取消收藏
export function publicElemFavoritiesService(fileId) {
    return request.post(`/componentLibrary/v3/public/favorites/${fileId}`);
}

// 公共构件-模型查看
export function publicElemViewModelService(data) {
    return request.post('/componentLibrary/v3/public/viewDataSetModel', data);
}

// 我的构件-重名校验
export function privateElemCheckNameService(data) {
    return request.post('/componentLibrary/v3/private/checkNodeNames', data);
}

// 我的构件-上传
export function privateElemCreateUploadService(data, headers) {
    return request.post('/componentLibrary/v3/private/create', data, headers);
}

// 我的构件-暂停上传
export function privateElemPauseUploadService(data, headers) {
    return request.post('/componentLibrary/v3/private/pause', data, headers);
}

// 我的构件-批量暂停上传
export function privateElemBatchPauseUploadService(data) {
    return request.post('/componentLibrary/v3/private/batchPause', data);
}

// 我的构件-文件列表
export function privateElemFileListService(data) {
    return request.post('/componentLibrary/v3/private/fileList', data);
}

// 我的构件-转换队列
export function privateElemQueueService(data) {
    return request.post('/convertQueue/v3/getClPrivateConvertQueue', data);
}

// 我的构件-创建分组
export function privateElemAddLevelNodeService(data) {
    return request.post('/componentLibrary/v3/private/addLevelNode', data);
}

// 我的构件-删除分组
export function privateElemDeleteLevelNodeService(data) {
    return request.post('/componentLibrary/v3/private/deleteLevelNode', data);
}

// 我的构件-更改分组名称
export function privateElemUpdateNodeNameService(data) {
    return request.post('/componentLibrary/v3/private/updateNodeName', data);
}

// 我的构件-移动分组
export function privateElemMoveNodeService(data) {
    return request.post('/componentLibrary/v3/private/move', data);
}

// 我的构件-批量移动分组
export function privateElemBatchMoveNodeService(data) {
    return request.post('/componentLibrary/v3/private/batchMove', data);
}

// 我的构件-目录树
export function privateElemCatalogService(data) {
    return request.post('/componentLibrary/v3/private/getTree', data);
}

// 我的构件-列表
export function privateElemListService(data) {
    return request.post('/componentLibrary/v3/private/list', data);
}

// 我的构件-删除构件
export function privateElemDeleteService(fileId) {
    return request.post(`/componentLibrary/v3/private/delete/${fileId}`);
}

// 我的构件-批量删除构件
export function privateElemBatchDeleteService(data) {
    return request.post('/componentLibrary/v3/private/delete', data);
}

// 我的构件-上传缩略图
export function uploadPrivateElemThumbnailService(data) {
    return request.post('/componentLibrary/v3/private/clThumbnail/upload', data);
}

// 我的构件-更改缩略图
export function privateElemChangeThumbnailService(data) {
    return request.post('/componentLibrary/v3/private/changeThumbnail', data);
}

// 我的构件-缩略图列表
export function privateElemThumbnailListService(fileId) {
    return request.post(`/componentLibrary/v3/private/thumbnails/${fileId}`);
}

// 我的构件-模型查看
export function privateElemViewModelService(data) {
    return request.post('/componentLibrary/v3/private/viewDataSetModel', data);
}

/**
 * 离线数据包功能
 */

// 获取导出列表
export function getOfflineExportListService(data) {
    return request.post('/OfflinePackage/v3/GetExportList', data);
}

// 获取数据集选择列表
export function getOfflineDataSetSelectListService(data) {
    return request.post('/OfflinePackage/v3/GetDataSetSelectList', data);
}

// 获取场景选择列表
export function getOfflineSceneSelectListService(data) {
    return request.post('/OfflinePackage/v3/GetSceneSelectList', data);
}

// 导出数据集校验
export function offlineDataSetExportCheckService(data) {
    return request.post('/OfflinePackage/v3/ExportDataSetCheck', data);
}

// 导出场景校验
export function offlineSceneExportCheckService(data) {
    return request.post('/OfflinePackage/v3/ExportSceneCheck', data);
}

// 导出数据集
export function offlineDataSetExportService(data) {
    return request.post('/OfflinePackage/v3/ExportDataSet', data);
}

// 设置密码和过期时间
export function updateOfflinePackageValidityService(data) {
    return request.post('/OfflinePackage/v3/SetPasswordAndTime', data);
}

// 导出场景
export function offlineSceneExportService(data) {
    return request.post('/OfflinePackage/v3/ExportScene', data);
}

// 导出删除
export function deleteOfflineExportService(dataId) {
    return request.delete(`/OfflinePackage/v3/delete/${dataId}`);
}

// 批量导出删除 
export function batchDeleteOfflineExportService(data) {
    return request.delete('/OfflinePackage/v3/batchDelete', { data });
}

// 重新导出
export function reOfflineExportService(dataId) {
    return request.post(`/OfflinePackage/v3/ReExport/${dataId}`);
}


/**
 * 数据统计功能
 */

// 当日请求统计(按接口统计)
export function getTodayStatisticsByUrlService(data) {
    return request.post('/auditStatistics/TodayStatistics/ByUrl', data);
}

// 当日请求统计(按用户统计)
export function getTodayStatisticsByUserService(data) {
    return request.post('/auditStatistics/TodayStatistics/ByUserId', data);
}

// 请求统计列表
export function getStatisticsListService(data) {
    return request.post('/auditStatistics/list', data);
}

// 请求统计详情
export function getStatisticsDetailsService(data) {
    return request.post('/auditStatistics/log/actions', data);
}

// 异常统计
export function getExceptionRecordService(data) {
    return request.post('/exceptionRecord/list', data);
}

// 文件下载
export function getFileDownloadRecordService(data) {
    return request.post('/fileDownloadRecord/list', data);
}

/**
 * 扩展属性相关
 */

// 创建扩展属性分组
export function createExtendParamGroupService(data) {
    return request.post('/element/v3/addElementExtendParamGroup', data);
}

// 修改扩展属性分组
export function updateExtendParamGroupService(data) {
    return request.put('/element/v3/updateElementExtendParamGroup', data);
}

// 删除扩展属性分组
export function deleteExtendParamGroupService(data) {
    return request.delete('/element/v3/deleteElementExtendParamGroup', { data });
}

// 获取扩展属性分组列表
export function getExtendParamGroupListService(data) {
    return request.post('/element/v3/getElementExtendParamGroups', data);
}

// 获取扩展属性列表
export function getExtendParamsService(data) {
    return request.post('/element/v3/getElementExtendParams', data);
}

// 创建扩展属性
export function createExtendParamService(data) {
    return request.put('/element/v3/addElementExtendParams', data);
}

// 修改扩展属性
export function updateExtendParamService(data) {
    return request.post('/element/v3/updateElementExtendParam', data);
}

// 根据分组删除扩展属性
export function deleteExtendParamByGroupService(data) {
    return request.delete('/element/v3/deleteElementExtendParamByGroup', { data });
}

// 删除扩展属性
export function deleteExtendParamByIdService(data) {
    return request.delete('/element/v3/deleteElementExtendParamById', { data });
}

// 根据构件id查询目录树节点路径及属性信息
export function getElemDetailByIdService(data) {
    return request.post('/element/v3/getTreeNodePathInfoByElementIntId', data);
}

/**
 * 视口相关
 */

// 获取视口列表
export function getSceneViewportListService(sceneId) {
    return request.get(`/scene/v3/viewport/getList/${sceneId}`);
}

// 获取视口详情
export function getSceneViewportDetailsService(viewportId) {
    return request.get(`/scene/v3/viewport/${viewportId}`);
}

// 新增视口
export function createSceneViewportService(data) {
    return request.post('/scene/v3/viewport/create', data);
}

// 更新视口
export function updateSceneViewportService(data) {
    return request.put('/scene/v3/viewport/update', data);
}

// 删除视口
export function deleteSceneViewportService(viewportId) {
    return request.delete(`/scene/v3/viewport/delete/${viewportId}`);
}

// 更新视口视角
export function updateSceneViewportImgService(data) {
    return request.put('/scene/v3/viewport/updateVisualAngle', data);
}

// 设置主视口
export function setSceneViewportDefaultService(viewportId) {
    return request.post(`/scene/v3/viewport/setDefault/${viewportId}`);
}

// 重置主视口
export function resetSceneViewportDefultService(sceneId) {
    return request.post(`/scene/v3/viewport/resetDefault/${sceneId}`);
}

/**
 * 批注相关接口
 */

// 获取批注列表
export function getSceneAnnotationListService(sceneId) {
    return request.get(`/scene/v3/annotation/getList/${sceneId}`);
}

// 新增批注
export function createSceneAnnotationService(data) {
    return request.post('/scene/v3/annotation/create', data);
}

// 更新批注
export function updateSceneAnnotationService(data) {
    return request.put('/scene/v3/annotation/update', data);
}

// 删除批注
export function deleteSceneAnnotationService(annotationId) {
    return request.delete(`/scene/v3/annotation/delete/${annotationId}`);
}

// 获取批注类型
export function getAnnotationTypeListService(data) {
    return request.post('/scene/v3/annotation/getTypeList', data)
}

// 获取批注详情
export function getAnnotationDetailsService(annotationId) {
    return request.get(`/scene/v3/annotation/${annotationId}`);
}

// 创建批注附件上传索引
export function createAnnotationAttachmentUploadService(data) {
    return request.post('/scene/v3/annotation/attachment/create', data);
}

// 查询批注附件列表
export function getAnnotationAttachmentListService(annotationId) {
    return request.get(`/scene/v3/annotation/getAttachments/${annotationId}`);
}

// 删除批注附件
export function deleteAnnotationAttachmentService(attachmentId) {
    return request.delete(`/scene/v3/annotation/deleteAttachment/${attachmentId}`);
}

// 查询批注评论列表
export function getAnnotationCommentListService(data) {
    return request.post('/scene/v3/annotation/getPagedComments', data);
}

// 创建批注评论
export function createAnnotationCommentService(data) {
    return request.post('/scene/v3/annotation/addComment', data);
}

// 删除批注评论
export function deleteAnnotationCommentService(commentId) {
    return request.delete(`/scene/v3/annotation/deleteComment/${commentId}`);
}

/**
 * 锚点相关
 */

// 获取锚点列表
export function getSceneAnchorListService(sceneId) {
    return request.get(`/scene/v3/anchorPoint/getList/${sceneId}`);
}

// 新增锚点
export function createSceneAnchorService(data) {
    return request.post('/scene/v3/anchorPoint/create', data);
}

// 更新锚点
export function updateSceneAnchorService(data) {
    return request.put('/scene/v3/anchorPoint/update', data);
}

// 删除锚点
export function deleteSceneAnchorService(anchorPointId) {
    return request.delete(`/scene/v3/anchorPoint/delete/${anchorPointId}`);
}

// 获取锚点详情
export function getAnchorDetailsService(anchorPointId) {
    return request.get(`/scene/v3/anchorPoint/${anchorPointId}`);
}

// 获取锚点分组列表
export function getSceneAnchorGroupListService(sceneId) {
    return request.get(`/scene/v3/anchorPoint/getGroupList/${sceneId}`);
}

// 新增锚点分组
export function createSceneAnchorGroupService(data) {
    return request.post('/scene/v3/anchorPoint/addGroup', data);
}

// 修改锚点分组名称
export function updateAnchorGroupNameService(data) {
    return request.put('/scene/v3/anchorPoint/updateGroupName', data);
}

// 修改锚点分组聚合状态
export function updateGroupMergeStatusService(data) {
    return request.put('/scene/v3/anchorPoint/updateAggregationStatus', data);
}

// 删除锚点分组
export function deleteSceneAnchorGroupService(data) {
    return request.delete('/scene/v3/anchorPoint/deleteGroup', { data })
}

// 获取锚点类型列表
export function getAnchorTypeListService(data) {
    return request.post('/scene/v3/anchorPoint/getTypeList', data)
}

// 获取锚点标识图标列表
export function getAnchorIconListService(data) {
    return request.post('/scene/v3/anchorPoint/getIconList', data)
}

// 删除锚点图标
export function deleteAnchorIconService(iconId) {
    return request.delete(`/scene/v3/anchorPoint/deleteIcon/${iconId}`);
}

// 创建锚点附件上传索引
export function createAnchorAttachmentUploadService(data) {
    return request.post('/scene/v3/anchorPoint/attachment/create', data);
}

// 查询锚点附件列表
export function getAnchorAttachmentListService(anchorPointId) {
    return request.get(`/scene/v3/anchorPoint/getAttachments/${anchorPointId}`);
}

// 删除锚点附件
export function deleteAnchorAttachmentService(attachmentId) {
    return request.delete(`/scene/v3/anchorPoint/deleteAttachment/${attachmentId}`);
}

// 查询锚点评论列表
export function getAnchorCommentListService(data) {
    return request.post('/scene/v3/anchorPoint/getPagedComments', data);
}

// 创建锚点评论
export function createAnchorCommentService(data) {
    return request.post('/scene/v3/anchorPoint/addComment', data);
}

// 删除锚点评论
export function deleteAnchorCommentService(commentId) {
    return request.delete(`/scene/v3/anchorPoint/deleteComment/${commentId}`);
}